module.exports = __webpack_public_path__ + "img/foil_cutter.a282324e.png";